import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'

import styles from './styles.module.scss'

export const TextHeaderEs = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Adivina dónde está el dinero."
                highlights={[
                    { word: 'Adivina' },
                    { word: 'dónde' },
                    { word: 'está' },
                    { word: 'el' },
                    { word: 'dinero.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['dónde']}
                className={styles.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>¡Tienes tres intentos!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
